import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CommonHeader from '../../util_components/common_header';
import { get_api } from '../../../redux/api_funcs';
import * as actions from '../../../redux/action_creators';
import { get_api_url } from '../../../utils/urls';

interface Session {
  session_uuid: string;
  group_session_name: string;
  start_time: string;
  end_time: string;
  teacher_uuid: string;
  teacher_first_name: string;
}

interface RootState {
  home: {
    iana_timezone: string;
  };
}

const ManualCropping: React.FC = () => {
  const dispatch = useDispatch();
  const iana_timezone = useSelector((state: RootState) => state.home.iana_timezone);

  const [loading, setLoading] = useState<boolean>(false);
  const [manual_cropping, setManualCropping] = useState<Session[]>([]);

  useEffect(() => {
    load_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load_data = (): void => {
    setLoading(true);
    let url = get_api_url('/v2/crons-tasks/sessions_pending_crop');
    url = url.replace('/cms/api', '');
    get_api(url, true)
      .then((res: any) => {
        console.log(res.data);
        setManualCropping([...res.data.data.sessions]);
        setLoading(false);
      })
      .catch((e: any) => {
        let err_message: string;
        try {
          err_message = e.response.data.message;
        } catch (err) {
          err_message = 'Some error occurred. Please contact dev team.';
        }
        dispatch(actions.set_notification_variable(true, 'error', err_message));
        setLoading(false);
      });
  };

  return (
    <CommonHeader loading={loading} title="Manual Cropping" show_back>
      <div className="cus-table">
        <div className="ct-row text-gray-700">
          <div className="ct-col">Group Session Name</div>
          <div className="ct-col">
            <div>Start Time</div>
            <div className="ct-sm-font">(Dur)</div>
          </div>
          <div className="ct-col">
            <div>End Time</div>
            <div className="ct-sm-font">(Dur)</div>
          </div>
          <div className="ct-col">Teacher First Name</div>
        </div>

        {manual_cropping
          ?.slice()
          ?.sort((a, b) => {
            const aStart = new Date(a.start_time).getTime();
            const bStart = new Date(b.start_time).getTime();
            const aEnd = new Date(a.end_time).getTime();
            const bEnd = new Date(b.end_time).getTime();

            if (bStart !== aStart) return bStart - aStart;
            return bEnd - aEnd;
          })
          ?.map((sessions) => (
            <div className="ct-row" key={sessions.session_uuid}>
              <div className="ct-col">{sessions.group_session_name}</div>
              <div className="ct-col">
                <div>{sessions.start_time}</div>
              </div>
              <div className="ct-col">
                <div>{sessions.end_time}</div>
              </div>
              <div className="ct-col">{sessions.teacher_first_name}</div>
              <div className="mr-4">
                <a
                  href={`http://hridaya.myyogateacher.com/groupsessiondetails?session_uuid=${sessions.session_uuid}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-auto block hover:opacity-70"
                  aria-label="Open session details"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.5029 8.33335C17.9631 8.33335 18.3362 7.96025 18.3362 7.50002V2.50002C18.3362 2.03979 17.9631 1.66669 17.5029 1.66669H12.4999C12.0396 1.66669 11.6665 2.03978 11.6665 2.50002C11.6665 2.96025 12.0396 3.33335 12.4999 3.33335H15.4912L8.31898 10.5055C7.99355 10.8309 7.99355 11.3586 8.31898 11.684C8.64446 12.0095 9.17204 12.0095 9.49746 11.684L16.6695 4.512V7.50002C16.6695 7.96025 17.0426 8.33335 17.5029 8.33335ZM4.16663 4.16669C2.78592 4.16669 1.66663 5.28598 1.66663 6.66669V15.8334C1.66663 17.2141 2.78592 18.3334 4.16663 18.3334H13.3333C14.714 18.3334 15.8333 17.2141 15.8333 15.8334V10.8334C15.8333 10.3731 15.4602 10 15 10C14.5397 10 14.1666 10.3731 14.1666 10.8334V15.8334C14.1666 16.2936 13.7935 16.6667 13.3333 16.6667H4.16663C3.70639 16.6667 3.33329 16.2936 3.33329 15.8334V6.66669C3.33329 6.20645 3.70639 5.83335 4.16663 5.83335H9.16663C9.62688 5.83335 9.99996 5.46025 9.99996 5.00002C9.99996 4.53979 9.62688 4.16669 9.16663 4.16669H4.16663Z"
                      fill="black"
                    />
                  </svg>
                </a>
              </div>
            </div>
          ))}

        {!loading && manual_cropping.length === 0 && (
          <div className="text-center py-4 text-gray-500">No sessions pending crop</div>
        )}
      </div>
    </CommonHeader>
  );
};

export default ManualCropping;
